import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

/** TODO:  */
@ngCore.Component({
  imports: [
    ds.input.code.Component,
    ds.input.datepicker.Component,
    ds.input.dateRange.single.Component,
    ds.input.dateRange.multiple.Component,
    ds.input.number.Component,
    ds.input.radio.option.Component,
    ds.input.radio.options.Component,
    ds.input.radio.value.Directive,
    ds.input.text.Component,
  ],
  selector: 'atn-intrinsic-input',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** TODO:  */
  public readonly labelSg = ngCore.input<string>(undefined, {
    alias: 'label',
  })

  /** @see {@link ents.core.dms.data.Value.ValueWithType.Strict} */
  public readonly typedValueSg = ngCore.model.required<
    ents.core.dms.data.Value.ValueWithType.Strict<ents.core.common.value.types.Intrinsic>
  >({
    alias: 'typedValue',
  })

  /** @see {@link ents.core.common.value.types.Intrinsic} */
  public readonly IntrinsicEnum = ents.core.common.value.types.Intrinsic

  /** {@link ds.input.code.Component} returns unknown upon (jsonChange) event so we need to try to cast it to object */
  public codeChangeHandler(
    type: ents.core.common.value.types.Intrinsic.Object,
    value: unknown,
  ) {
    const parsedValue = ents.core.common.value.Raw.cast(
      value,
      ents.core.common.value.types.Intrinsic.Object,
    )

    this.typedValueSg.set({ type, value: parsedValue })
  }
}
